/* HP Sections — IntersectionObserver scroll reveal */
(function () {
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('[data-hp-reveal]').forEach(function (el) {
      el.classList.add('hp-revealed');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('hp-revealed');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
  );

  document.querySelectorAll('[data-hp-reveal]').forEach(function (el) {
    observer.observe(el);
  });
})();
